import { DownloadOutlined } from "@ant-design/icons";
import i18n from "i18next";
import type { FC } from "react";

import { getAssignedDataGroup } from "../../core/router/auth";
import { ResourceName } from "../../core/router/config/ResourceName";
import type { Entity } from "../../core/types/fe";
import { SecondaryButton } from "../Buttons/components/ActionButton";
import { useExportTableDataMutation } from "../Table";

type XMLExportButtonProps = {
    items?: Entity[];
};

export const XMLExportButton: FC<XMLExportButtonProps> = ({ items = [] }) => {
    const [exportRequest] = useExportTableDataMutation();
    const isDisabled = items.length === 0;

    const handleClick = () => {
        if (isDisabled) return;

        const dataGroup = getAssignedDataGroup();
        const params = new URLSearchParams();
        items.forEach((item) => params.append("ids", String(item.id)));

        const now = new Date();
        const pad = (n: number) => String(n).padStart(2, "0");
        const timestamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}-${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
        const downloadFileName = `ApplicationProfiles-${timestamp}.xml`;

        exportRequest({
            url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APPLICATION_PROFILE_LISTS}/xml-export?${params.toString()}`,
            method: "GET",
            downloadFileName,
        });
    };

    return (
        <SecondaryButton name="xml_export_button" onClick={handleClick} disabled={isDisabled} icon={<DownloadOutlined />}>
            {i18n.t("button.xmlExport")}
        </SecondaryButton>
    );
};
